import { render, staticRenderFns } from "./BandejaLinkPacientePTIPresuntivoComponente.vue?vue&type=template&id=18226898&scoped=true"
import script from "./BandejaLinkPacientePTIPresuntivoComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacientePTIPresuntivoComponente.vue?vue&type=script&lang=js"
import style0 from "./BandejaLinkPacientePTIPresuntivoComponente.vue?vue&type=style&index=0&id=18226898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18226898",
  null
  
)

export default component.exports